import { ApiToken } from '../types/entities/api-token.entity';
import { CreateApiTokenRequest } from '../types/requests/api-token.requests';
import { CreateApiTokenResponse } from '../types/responses/api-token.responses';
import { api } from './client';

interface ApiTokensResponse {
    status: string;
    data: {
        tokens: ApiToken[];
    };
}

export const tokenService = {
    getAll: async (): Promise<ApiToken[]> => {
        const response = await api.get<ApiTokensResponse>('/api-tokens');
        return response.data.data.tokens;
    },

    create: async (data: CreateApiTokenRequest): Promise<CreateApiTokenResponse> => {
        const response = await api.post<{ data: CreateApiTokenResponse }>('/api-tokens', data);
        return response.data.data;
    },

    delete: async (id: number): Promise<void> => {
        await api.delete(`/api-tokens/${id}`);
    }
}; 